import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DateFormatService } from 'src/app/modules/core/services/dateFormat.service';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class NgbDateFnsDateParserFormatter extends NgbDateParserFormatter {
	constructor(private dateFormatService: DateFormatService) {
		super();
	}

	parse(value: string): NgbDateStruct {
		if (!value) {
			return null;
		}

		const m = new Date(Date.parse(value));

		return {
			day: m.getDate(),
			month: m.getMonth() + 1,
			year: m.getFullYear()
		};
	}

	format(date: NgbDateStruct): string {
		if (date == null) {
			return null;
		}

		const m = new Date(date.year, date.month - 1, date.day);

		return this.dateFormatService.formatDate(m);
	}
}
